import { Vector3 } from 'three'
import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level5: LevelConfig = {
  grid: [
    padRow(
      [
        null,
        null,
        null,
        null,
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'red' } },
        'SW',
      ],
      'prepend',
      false,
    ),
    padRow(
      [
        null,
        null,
        null,
        null,
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'lawngreen' } },
        ['SW', 'NS'],
      ],
      'prepend',
      false,
    ),
    padRow([null, null, null, null, null, null, 'NS'], 'prepend', false),
    padRow(
      [
        null,
        null,
        null,
        'W',
        { track: 'WE', vehicle: { type: 'wagon', color: 'blue' } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'aqua' } },
        ['SW', 'NS'],
      ],
      'prepend',
      false,
    ),
    padRow([null, null, null, null, null, null, 'NS'], 'prepend', false),
    padRow(
      [
        'WE',
        'WE',
        'WE',
        'WE',
        { track: 'WE', vehicle: 'locomotive' },
        'WE',
        ['WE', 'NE'],
        { track: 'WE', exit: 'E' },
      ],
      'fill',
    ),
  ],
  goal: {
    sequence: ['blue', 'red', 'lawngreen', 'aqua'],
    offset: new Vector3(-5, 0, -1.5),
  },
}
